export default [
  {
    _id: "0c06bf24-58f7-4013-b9c1-f2fce13d8e4a",
    title: "2",
    uri: "urn:li:share:7249301296283844610",
  },
  {
    _id: "67b6404a-461a-48df-8ed8-6e782d667604",
    title: "3",
    uri: "urn:li:ugcPost:7240967824171487232",
  },
  {
    _id: "7c3afeb7-8e30-4bec-be0c-16b2f8ded1b9",
    title: "1",
    uri: "urn:li:share:7248539806882770945",
  },
  {
    _id: "drafts.f737cfb9-91b4-4e13-8fb8-b7e853005fb9",
    title: "4",
    uri: "urn:li:share:7241386364745699329",
  },
  {
    _id: "ee299eb8-9ec3-4a7d-85d9-368253c68107",
    title: "5",
    uri: "urn:li:share:7240252904949833731",
  },
];
